/* TC Academy — Animations v3.1 + Sticky Nav */
(function(){
  /* ── Sticky Nav — show on scroll up, hide on scroll down ── */
  function initStickyNav(){
    var nav=document.querySelector('.tc-nav2,.tc-nav,nav[id*="tc-"]');
    if(!nav)return;
    var lastY=0;
    window.addEventListener('scroll',function(){
      var y=window.scrollY;
      if(y>lastY&&y>120)nav.classList.add('hidden');
      else if(y<lastY)nav.classList.remove('hidden');
      nav.classList.toggle('scrolled',y>30);
      lastY=y;
    },{passive:true});
  }

  /* ── Scroll Reveal ── */
  var obs=new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if(en.isIntersecting){en.target.classList.add('tc-visible');obs.unobserve(en.target);}
    });
  },{threshold:0.1,rootMargin:'0px 0px -40px 0px'});

  function initObs(){
    document.querySelectorAll('.tc-fade-up').forEach(function(el){obs.observe(el);});
  }

  /* ── Login Gate for purchases ── */
  function setupGate(){
    var loggedIn=document.querySelector('a[href="/account/logout"]')||document.cookie.indexOf('_shopify_sa_p')>-1;
    if(loggedIn)return;
    var btns=document.querySelectorAll('.product-form__submit,.shopify-payment-button,button[name="add"]');
    btns.forEach(function(b){b.style.display='none';});
    document.querySelectorAll('form[action="/cart/add"]').forEach(function(f){
      f.addEventListener('submit',function(e){e.preventDefault();window.location.href='/account/login';});
    });
  }

  /* ── Smooth Scroll ── */
  document.addEventListener('click',function(e){
    var a=e.target.closest('a[href*="#"]');
    if(!a)return;
    var href=a.getAttribute('href');
    var hash=href.indexOf('#')>-1?href.substring(href.indexOf('#')):'';
    if(!hash||hash==='#')return;
    var target=document.querySelector(hash);
    if(target){
      e.preventDefault();
      var d=document.getElementById('tc-drawer2');
      if(d)d.classList.remove('open');
      setTimeout(function(){target.scrollIntoView({behavior:'smooth',block:'start'});},50);
    }
  });

  /* ── Init ── */
  function init(){initStickyNav();initObs();setupGate();}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}
  else{init();}
})();

